import React from "react";
import styles from "./ViewPlaceholder.module.css";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

function Profile() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const isAuthenticated = !!(user && user.token);

    const handleLogout = () => {
        logout();
        // after logout, send user to the landing page
        navigate("/");
    };

    if (!isAuthenticated) {
        // Show guest view with prompts to login or signup
        return (
            <div className={styles.placeholderContainer}>
                {/* back header */}
                <div className={styles.viewHeader}>
                    <button
                        type="button"
                        className={styles.backBtn}
                        aria-label="Back to home"
                        onClick={() => navigate('/home')}
                    >
                        <span aria-hidden>←</span>
                        <span className={styles.backLabel}>Home</span>
                    </button>
                </div>
                <h1>Profile</h1>
                <p>You are browsing as a guest. To save progress and access full features, please login or sign up.</p>
                <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem" }}>
                    <Link to="/login" className={styles.button}>Login</Link>
                    <Link to="/signup" className={styles.button}>Sign up</Link>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.placeholderContainer}>
            {/* back header */}
            <div className={styles.viewHeader}>
                <button
                    type="button"
                    className={styles.backBtn}
                    aria-label="Back to home"
                    onClick={() => navigate('/')}
                >
                    <span aria-hidden>←</span>
                    <span className={styles.backLabel}>Home</span>
                </button>
            </div>
            <h1>Profile</h1>
            <div className={styles.profileCard}>
                <p><strong>Username:</strong> {user.username || "-"}</p>
                <p><strong>Email:</strong> {user.email || "-"}</p>
                <p><strong>Score:</strong> {typeof user.score === 'number' ? user.score : '-'}</p>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
                    <button className={styles.logoutBtn} onClick={handleLogout}>Logout</button>
                </div>
            </div>
        </div>
    );
}

export default Profile;
